export default [
    {
        path: '/dossier/complaint',
        component: () => import('@/views/Dossier/Complaint/index'),
        props: true,
    },
];
